import React, { Component } from 'react'
import logo from '../logo.gif'

export default class PaymentSuccess extends Component {
  constructor (props) {
    super(props)
    this.state = {
      status: 'loading' // 'loading' | 'success' | 'failed' | 'invalid'
    }
  }

  componentDidMount () {
    // Clear session and prevent back navigation
    sessionStorage.clear()
    window.history.pushState(null, '', window.location.href)
    window.onpopstate = function () {
      window.history.pushState(null, '', window.location.href)
    }

    // Get identifiers from URL query params
    const params = new URLSearchParams(window.location.search)
    const tranRef = params.get('tranRef') || params.get('tran_ref')
    const ptId = params.get('ptId')

    if (!tranRef && !ptId) {
      this.setState({ status: 'invalid' })
      return
    }

    // Verify payment with backend
    let verifyUrl = `${process.env.REACT_APP_API_URL}/api/Submit/VerifyPayment?`
    if (tranRef) verifyUrl += `tranRef=${encodeURIComponent(tranRef)}`
    if (ptId) verifyUrl += `${tranRef ? '&' : ''}ptId=${encodeURIComponent(ptId)}`

    fetch(verifyUrl)
      .then(res => res.json())
      .then(res => {
        const resultStatus = res.status || 'failed'
        this.setState({ status: resultStatus })
        // Strip tranRef from URL so back-navigation shows "invalid"
        window.history.replaceState(null, '', window.location.pathname)
      })
      .catch(() => {
        this.setState({ status: 'failed' })
        window.history.replaceState(null, '', window.location.pathname)
      })
  }

  render () {
    const { status } = this.state

    if (status === 'loading') {
      return (
        <div id='mainContainer'>
          <div id='designBorder'></div>
          <img src={logo} className='center main-logo' alt='logo' />
          <div id='main-page' style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ width: 40, height: 40, border: '4px solid #e0e0e0', borderTop: '4px solid #3168CE', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 20px' }}></div>
            <p style={{ fontSize: 16, color: '#555' }}>Verifying your payment...</p>
          </div>
        </div>
      )
    }

    if (status === 'invalid') {
      return (
        <div id='mainContainer'>
          <div id='designBorder'></div>
          <img src={logo} className='center main-logo' alt='logo' />
          <div id='main-page' style={{ textAlign: 'center', padding: '50px 20px' }}>
            <div style={{ fontSize: 48, color: '#c0392b', marginBottom: 20 }}>&#9888;</div>
            <h3 style={{ color: '#c0392b', marginBottom: 16 }}>Page Not Accessible</h3>
            <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6 }}>
              This page can only be reached after a successful payment through the application process.
            </p>
            <button
              onClick={() => window.location.replace(window.location.pathname.replace(/\/[^/]*$/, '/login'))}
              style={{
                display: 'inline-block',
                padding: '10px 24px',
                background: '#3168CE',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                fontSize: 14,
                marginTop: 20,
                cursor: 'pointer'
              }}
            >
              Go to Login
            </button>
          </div>
        </div>
      )
    }

    if (status === 'failed') {
      return (
        <div id='mainContainer'>
          <div id='designBorder'></div>
          <img src={logo} className='center main-logo' alt='logo' />
          <div id='main-page' style={{ textAlign: 'center', padding: '50px 20px' }}>
            <div style={{ fontSize: 48, color: '#c57000', marginBottom: 20 }}>&#10007;</div>
            <h3 style={{ color: '#c57000', marginBottom: 16 }}>Payment Not Successful</h3>
            <p style={{ fontSize: 16, color: '#333', lineHeight: 1.6, marginBottom: 12 }}>
              Your payment could not be verified. This may be due to a declined transaction or a processing issue.
            </p>
            <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6, marginBottom: 12 }}>
              Your application data has been saved. Please contact the Admissions Office for assistance with completing your payment.
            </p>
            <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6, marginBottom: 20 }}>
              Email: <a href='mailto:admissions@tkh.edu.eg' style={{ color: '#3168CE' }}>admissions@tkh.edu.eg</a>
            </p>
          </div>
        </div>
      )
    }

    // status === 'success'
    return (
      <div id='mainContainer'>
        <div id='designBorder'></div>
        <img src={logo} className='center main-logo' alt='logo' />
        <div id='main-page' style={{ textAlign: 'center', padding: '50px 20px' }}>
          <div style={{ fontSize: 48, color: '#27ae60', marginBottom: 20 }}>&#10003;</div>
          <h3 style={{ color: '#3168CE', marginBottom: 16 }}>Payment Successful</h3>
          <p style={{ fontSize: 16, color: '#333', lineHeight: 1.6, marginBottom: 12 }}>
            Your payment has been received and your application has been submitted successfully.
          </p>
          <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6, marginBottom: 12 }}>
            The Admissions Committee will review your application and you will be officially notified once the evaluation process is completed.
          </p>
          <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6, marginBottom: 20 }}>
            Shortlisted applicants will be invited for an interview as part of the assessment process.
          </p>
          <button
            onClick={() => window.location.replace('https://tkh.edu.eg')}
            style={{
              display: 'inline-block',
              padding: '10px 24px',
              background: '#3168CE',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              fontSize: 14,
              marginTop: 12,
              cursor: 'pointer'
            }}
          >
            Visit TKH Website
          </button>
        </div>
      </div>
    )
  }
}
